import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectTypography } from "../../utils/injectTypography.mjs.mjs";
import { injectOSXFontSmoothing } from "../../utils/injectOSXFontSmoothing.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
export const StyledContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledContainer", componentId: "auir-611444a-1for02x" }) `
  ${(props) => injectTypography(props, props.size === 'small' ? 'copy2' : 'copy1')}
  align-items: start;

  color: var(${(props) => props.theme.colors.ui.secondary});

  text-align: ${(props) => props.alignment};
  ${injectOSXFontSmoothing(true)}
  ${injectSpacing('margin')}
`;
export const StyledValueUnitContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledValueUnitContainer", componentId: "auir-611444a-10rs3gg" }) `
  display: flex;
  gap: var(${(props) => props.theme.responsive.spacing.xs});
  justify-content: ${(props) => props.alignment === 'start' ? 'flex-start' : 'center'};
`;
export const StyledValue = styled.span.withConfig({ displayName: "auir-611444a-StyledValue", componentId: "auir-611444a-lwvtkq" }) `
  display: flex;
  align-items: start;

  color: var(${(props) => props.theme.colors.ui.primary});

  font-size: ${(props) => ({ small: '28px', medium: '40px', large: '52px' }[props.size])};
  font-family: var(${(props) => props.theme.fontFamily});
  font-stretch: 130%;
  line-height: 0.9em;
  text-indent: -0.1em;
  text-align: end;
  word-break: break-all;
`;
export const StyledUnit = styled.span.withConfig({ displayName: "auir-611444a-StyledUnit", componentId: "auir-611444a-1k7sep9" }) `
  margin-block-start: auto;

  line-height: ${(props) => ({ small: '1.2em', medium: '1.2em', large: '1.4em' }[props.size])};
  text-align: start;
  hyphens: auto;
`;
export const StyledDescription = styled.div.withConfig({ displayName: "auir-611444a-StyledDescription", componentId: "auir-611444a-8dw0i5" }) `
  display: inline-block;
  margin-block-start: var(
    ${(props) => ({
    small: props.theme.responsive.spacing.xs,
    medium: props.theme.responsive.spacing.s,
    large: props.theme.responsive.spacing.m,
}[props.size])}
  );
  text-align: start;
`;
export const StyledTitle = styled.div.withConfig({ displayName: "auir-611444a-StyledTitle", componentId: "auir-611444a-1wsykqt" }) `
  display: inline-block;
  margin-block-end: var(
    ${(props) => ({
    small: props.theme.responsive.spacing.s,
    medium: props.theme.responsive.spacing.m,
    large: props.theme.responsive.spacing.l,
}[props.size])}
  );
  text-align: start;
`;
//# sourceMappingURL=ValueWithUnit.styles.mjs.mjs.map